import React from "react";
import { useParams } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import SectionTitle from "../../components/SectionTitle";
import useProjectDetails from "../../hooks/useProjectDetails";
import AutoCarousel from "../../components/Carousel";
import WithHelmet from "../../utils/WithHelmet";

// Generate dynamic metadata based on the project
const pageTitle = "My Projects | Md Shahar Shitol";
const description = `Discover the details of a project created by Md Shahar Shitol. Explore the features, technologies, and implementation of this project, showcasing Md Shahar Shitol's expertise in creating dynamic and user-friendly web applications. Gain insights into the project's development process, challenges overcome, and the dedication to delivering high-quality solutions.`;

const keywords = [
  "about me",
  "full-stack web developer",
  "skills",
  "experience",
  "high-quality solutions",
  "md shahar shitol",
  "frontend developer",
  "hire me",
  "projects",
  "recruiting hire",
  "warehouse management",
  "rock paper sessiors",
  "bongodev",
  "management website",
];

const ProjectDetails = () => {
  const { id } = useParams();
  const [project] = useProjectDetails(id);

  return (
    <div
      className="font-sans md:p-10 p-3 py-10 mb-20"
      data-aos="fade-right"
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="700"
      data-aos-easing="ease-in-out"
    >
      <SectionTitle>Details</SectionTitle>
      <h1 className="text-2xl font-bold">{project.name}</h1>
      <div className="my-3">
        <a
          className="xs:w-full xs:block xs:text-center xs:text-xl"
          href={project?.liveSite}
          target={"_blank"}
          rel="noreferrer"
        >
          <button className="btn btn-xs m-1 hover:bg-accent hover:text-black hover:border-accent">
            Live Site &nbsp; <FiExternalLink />{" "}
          </button>
        </a>
        <a
          className="xs:w-full xs:block xs:text-center xs:text-xl"
          href={project?.clientCode}
          target={"_blank"}
          rel="noreferrer"
        >
          <button className="btn btn-xs m-1 hover:bg-accent hover:text-black hover:border-accent">
            Client Code &nbsp; <FiExternalLink />{" "}
          </button>
        </a>
        {project?.serverCode && (
          <a
            className="xs:w-full xs:block xs:text-center xs:text-xl "
            href={project?.serverCode}
            target={"_blank"}
            rel="noreferrer"
          >
            <button className="btn btn-xs m-1 hover:bg-accent hover:text-black hover:border-accent">
              Server Code &nbsp; <FiExternalLink />{" "}
            </button>
          </a>
        )}
      </div>
      <div className="carousel w-full my-5 shadow-md">
        <AutoCarousel project={project} />
      </div>
      <p>{project?.logndesc}</p>

      {project.features && (
        <>
          <h3 className="text-xl font-semibold mt-4 text-accent">Features:</h3>
          <ul className="list-disc ml-6">
            {project?.features?.map((feature) => (
              <li className="mb-2" key={feature}>
                {feature}
              </li>
            ))}
          </ul>
        </>
      )}
      {/* tech container */}
      <div className="">
        <h3 className="text-xl font-semibold mt-4 text-accent">Frontend:</h3>
        <p className="">
          {project?.frontend?.map((tech, index) => (
            <span className="mb-2" key={tech}>
              {tech}
              {index !== project.frontend.length - 1 && ","}{" "}
            </span>
          ))}
        </p>
      </div>

      {project.backend && (
        <div>
          <h3 className="text-xl font-semibold mt-4 text-accent">Backend:</h3>
          <p className="">
            {project?.backend?.map((tech, index) => (
              <span className="mb-2" key={tech}>
                {tech}
                {index !== project.backend.length - 1 && ","}{" "}
              </span>
            ))}
          </p>
        </div>
      )}
    </div>
  );
};

export default WithHelmet(ProjectDetails, pageTitle, description, keywords);
